export const STATUSES = [
  "Order Masuk", "Menunggu Desain/Film", "Antre Produksi", "Sedang Disablon",
  "Pengeringan/QC", "Packing", "Selesai", "Sudah Diambil/Dikirim",
];
export const DONE = STATUSES.slice(6);

export const STATUS_COLOR = {
  "Order Masuk": "bg-slate-600 text-white",
  "Menunggu Desain/Film": "bg-blue-600 text-white",
  "Antre Produksi": "bg-indigo-600 text-white",
  "Sedang Disablon": "bg-amber-500 text-white",
  "Pengeringan/QC": "bg-orange-500 text-white",
  "Packing": "bg-cyan-600 text-white",
  "Selesai": "bg-emerald-600 text-white",
  "Sudah Diambil/Dikirim": "bg-slate-900 text-white",
};

export const ROLE_LABEL = {
  admin: "Admin",
  head_operator: "Head Operator",
  operator: "Operator Produksi",
  gudang: "Gudang",
};

export const CATEGORY_LABEL = {
  cup: "Cup Polos",
  tinta: "Tinta / Cat Sablon",
  pendukung: "Bahan Pendukung",
  kemasan: "Kemasan",
};

export const CUP_TYPES = ["Plastik PP", "PET", "Paper Cup", "Cup Jelly", "Cup Puding", "Gelas Thai Tea", "Cup Oval", "Botol Plastik", "Mangkok Plastik"];
export const CUP_SIZES = ["8 oz", "10 oz", "12 oz", "14 oz", "16 oz", "18 oz", "20 oz", "22 oz", "24 oz", "250 ml", "350 ml", "500 ml", "1000 ml"];
export const PRINT_SIDES = ["1 Sisi", "2 Sisi", "Keliling 360°", "Depan", "Belakang", "Depan & Belakang", "Tutup Cup"];
export const PRIORITIES = ["Normal", "Tinggi", "Urgent"];

export const MOVE_LABEL = { masuk: "Masuk", keluar: "Keluar", opname: "Opname", produksi: "Produksi", reject: "Reject" };

export const rupiah = (v) => "Rp " + Math.round(Number(v) || 0).toLocaleString("id-ID");
export const num = (v) => (Number(v) || 0).toLocaleString("id-ID");

export const todayWIB = () => new Date(Date.now() + 7 * 3600e3).toISOString().slice(0, 10);

export const fmtDate = (s) => {
  if (!s) return "-";
  const d = new Date(s.length === 10 ? s + "T00:00:00" : s);
  return d.toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" });
};

export const fmtDateTime = (s) =>
  s ? new Date(s).toLocaleString("id-ID", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "-";

export function deadlineState(o) {
  if (DONE.includes(o.status)) return "done";
  const diff = (new Date(o.deadline + "T00:00:00") - new Date(todayWIB() + "T00:00:00")) / 864e5;
  if (diff < 0) return "late";
  if (diff <= 2) return "soon";
  return "ok";
}

export const waLink = (n, text) => {
  const d = (n || "").replace(/\D/g, "");
  const base = `https://wa.me/${d.startsWith("0") ? "62" + d.slice(1) : d}`;
  return text ? `${base}?text=${encodeURIComponent(text)}` : base;
};

export const EXPENSE_CATEGORIES = ["Pembelian Supplier", "Operasional", "Gaji", "Lainnya"];

export const PAYMENT_METHODS = ["Tunai", "BCA", "BRI"];

export const waReceipt = (o) => {
  const items = o.items.map((i) => `• ${i.cup_type} ${i.cup_size} x${num(i.qty)} pcs (${i.colors} warna${i.print_side ? ", " + i.print_side : ""}) = ${rupiah(i.subtotal)}`).join("\n");
  const pays = (o.payments || []).map((p) => `• ${fmtDate(p.date)} ${p.note} via ${p.method || "Tunai"}: ${rupiah(p.amount)}`).join("\n");
  return `*MACCA DESIGN PRINTING*\nNota Pesanan *${o.order_no}*\n\nHalo ${o.customer.name},\nTerima kasih atas pesanannya. Berikut rinciannya:\n\n${items}\n\nTotal: *${rupiah(o.total)}*\nDibayar: ${rupiah(o.paid)}${pays ? "\n" + pays : ""}\nSisa: *${rupiah(o.remaining)}*\nStatus: ${o.payment_status}\n\nTanggal order: ${fmtDate(o.order_date)}\nEstimasi selesai: ${fmtDate(o.deadline)}${o.notes ? `\nCatatan: ${o.notes}` : ""}\n\nTerima kasih 🙏`;
};

export const waDone = (o) =>
  `*MACCA DESIGN PRINTING*\n\nHalo ${o.customer.name},\nKabar baik! Pesanan Anda *${o.order_no}* sudah *SELESAI* dan siap diambil/dikirim.\n\n${o.items.map((i) => `• ${i.cup_type} ${i.cup_size} x${num(i.qty)} pcs`).join("\n")}\n\n${o.remaining > 0 ? `Sisa pembayaran: *${rupiah(o.remaining)}*\n\n` : "Pembayaran: *LUNAS*\n\n"}Silakan hubungi kami untuk pengambilan/pengiriman. Terima kasih 🙏`;
